import logo from '../../../../assets/logos/aye-logo.png'

export default function RegisterPageTopSection() {
  return (
    <div className="flex flex-col items-center justify-center mt-9 mx-2 sm:mx-0">
      <div className="flex flex-col items-center justify-center">
        <img src={logo} alt="Aye Logo" className="w-16 h-8" />
        <p className="text-lg mb-3 mt-12 text-center text-gray-600">
          Experience the future of payments
        </p>
      </div>
      <div className="flex flex-col items-center justify-center text-gray-700">
        <p className="text-center text-4xl font-semibold max-w-full mx-4 sm:mx-0">
          Start Paying With Your Face Today
        </p>
      </div>
    </div>
  )
}
